<template>
  <div>
    <b-card no-header>
      <form>

        <b-form-group
          label="Cliente"
          label-for="cliente"
          :label-cols="labelCols"
          horizontal>
          <b-input-group>
            <b-form-input 
              id="cliente"
              :value="cliente"
              readonly
              type="text"/>
          </b-input-group>
        </b-form-group>

        <b-form-group
          label="Comprobante"
          label-for="comprobante"
          :label-cols="labelCols"
          horizontal>
          <b-input-group>
            <b-form-input 
              id="comprobante"
              :value="comprobante"
              readonly
              type="text"/>
          </b-input-group>
        </b-form-group>

        <b-form-group
          label="Observaciones"
          label-for="observaciones"
          :label-cols="labelCols"
          description="Aclaraciones sobre el motivo de la cancelación">
          <b-form-textarea
            id="observaciones"
            v-model="$v.observaciones.$model" 
            rows="3"
            max-rows="5"
            :state="observacionesValidas"
            @blur.native="validate">
          </b-form-textarea>
          <b-form-invalid-feedback id="observacionesFeedback">
            {{ observacionesInvalidasMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          v-if="esFCE"
          :label-cols="labelCols"
          description="El comprobante anula un comprobante MyPYME (FCE) rechazado">
          <b-form-checkbox 
              id="anulaFacturaCreditoElectronica"
              v-model="anulaFacturaCreditoElectronica"
              :value="true"
              :unchecked-value="false">
              Anula Comprobante de Crédito Electrónico Rechazado
          </b-form-checkbox>
        </b-form-group>
      </form>

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  name: 'Cancelacion',
  components: {
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  props: {
    cliente: {
      type: String,
      default: '',
    },
    comprobante: {
      type: String,
      default: '',
    },
    esFCE: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      cancelacionMotivo: null,
      observaciones: '',
      anulaFacturaCreditoElectronica: false,

      noValidar: true,
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      labelCols: 2,
    }
  },
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres';
          }      
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      
      let save = Boolean(true);

      this.$v.$touch();

      // let save = Boolean(false);
      // let errorCancelacionMotivo = Boolean(false);
      // if (this.cancelacionMotivo) {
      //   if (this.cancelacionMotivo.id) {
      //     if (this.cancelacionMotivo.id != 0) {
      //       save = Boolean(true);
      //     }
      //   }
      // }
      // if (errorCancelacionMotivo) {
      //   this.cancelacionMotivoValido = false;
      //   this.cancelacionMotivoInvalidoMsj = "Debe seleccionar el motivo correspondiente.";
      // }

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          let params = {
            // cancelacionMotivoId: this.cancelacionMotivo.id,
            observaciones: this.observaciones.trim(),
            anulaFacturaCreditoElectronica: (/true/i).test(this.anulaFacturaCreditoElectronica)
          }
          this.$emit('cancelarComprobante', params)
        }
      }
    },
    cancelar() {
      this.$emit('cancelarCancelacion')
    },
    // cancelacionMotivoActualizado(cancelacionMotivoNombre) {
    //   this.cancelacionMotivo = this.getSelected(this.cancelacionesMotivos, cancelacionMotivoNombre);
      
    //   this.cancelacionMotivoValido = null;
    //   this.cancelacionMotivoInvalidoMsj = '';
    // },
  },
  validations: {
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
